import { render, staticRenderFns } from "./XMtools.vue?vue&type=template&id=5c8d483d&scoped=true"
import script from "./XMtools.vue?vue&type=script&lang=js"
export * from "./XMtools.vue?vue&type=script&lang=js"
import style0 from "./XMtools.vue?vue&type=style&index=0&id=5c8d483d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d483d",
  null
  
)

export default component.exports